<div class="card-title p-0">Key Management Services (KMS)</div>
<div class="card-container p-0">
    <div class="aws-logopart">
        <img style="display:none" src="../../../../assets/images/aws.svg">
    </div>
    <div class="aws-cover">
        <app-aws-managed-keys></app-aws-managed-keys>
    </div>
</div>